import { Text, View } from '@react-pdf/renderer'
import React from 'react'
import PdfTextBlockBottom from '../TextBlocks/PdfTextBlockBottom'
import PdfTextBlockTop from '../TextBlocks/PdfTextBlockTop'

const Header = ({ data, order }) => {

    return (
        <>
            <View
                style={{
                    flexDirection: "row",
                    display: "flex",
                    alignItems: "stretch",
                    padding: "10px",
                    backgroundColor: "#cccccc",
                    marginBottom: "15px"
                }}
            >
                <View
                    style={{
                        width: "11.111%",
                        display: "flex",
                        flexDirection: "column"
                    }}
                >
                    <PdfTextBlockBottom
                        title="JOB ID"
                        text={data.id}
                        disableRightBorder={true}
                        titleViewStyles={{ backgroundColor: "#fff" }}
                    />
                </View>
                <View
                    style={{
                        width: "11.111%",
                        display: "flex",
                        flexDirection: "column"
                    }}
                >
                    <PdfTextBlockBottom
                        title="REPEAT"
                        text={"required"}
                        disableRightBorder={true}
                        titleViewStyles={{ backgroundColor: "#fff" }}
                    />
                </View>
                <View
                    style={{
                        width: "11.111%",
                        display: "flex",
                        flexDirection: "column"
                    }}
                >
                    <PdfTextBlockBottom
                        title="GROUP"
                        text="required"
                        disableRightBorder={true}
                        titleViewStyles={{ backgroundColor: "#fff" }}
                    />
                </View>
                <View
                    style={{
                        width: "11.111%",
                        display: "flex",
                        flexDirection: "column"
                    }}
                >
                    <PdfTextBlockBottom
                        title="MODEL"
                        text={order.job_order_meta ? order.job_order_meta.model : "-"}
                        disableRightBorder={true}
                        titleViewStyles={{ backgroundColor: "#fff" }}
                    />
                </View>
                <View
                    style={{
                        width: "11.111%",
                        display: "flex",
                        flexDirection: "column"
                    }}
                >
                    <PdfTextBlockBottom
                        title="PART"
                        text={order.job_order_meta ? order.job_order_meta.part : "-"}
                        disableRightBorder={true}
                        titleViewStyles={{ backgroundColor: "#fff" }}
                    />
                </View>
                <View
                    style={{
                        width: "11.111%",
                        display: "flex",
                        flexDirection: "column",
                        marginRight: "10px"
                    }}
                >
                    <PdfTextBlockBottom
                        title={"Color"}
                        text={order.job_order_meta ? order.job_order_meta.color : "-"}
                        titleViewStyles={{ backgroundColor: "#fff" }}
                    />
                </View>


                <View
                    style={{
                        width: "11.111%",
                        display: "flex",
                        flexDirection: "column",
                    }}
                >
                    <PdfTextBlockBottom
                        title="TOTAL"
                        text="*"
                        titleViewStyles={{ backgroundColor: "#fff" }}
                        disableRightBorder
                    />
                </View>
                <View
                    style={{
                        width: "11.111%",
                        display: "flex",
                        flexDirection: "column",
                    }}
                >
                    <PdfTextBlockBottom
                        title="AVAILABLE"
                        text="*"
                        titleViewStyles={{ backgroundColor: "#fff" }}
                        disableRightBorder
                    />
                </View>
                <View
                    style={{
                        width: "11.111%",
                        display: "flex",
                        flexDirection: "column",
                    }}
                >
                    <PdfTextBlockBottom
                        title="SAMPLE PULL"
                        text="*"
                        titleViewStyles={{ backgroundColor: "#fff" }}
                    />
                </View>
            </View>
        </>

    )
}

export default Header